export {
  EStorageType,
  ELocalStorageKeys,
  ESessionStorageKeys,
  EOfferType,
  EPopupSubType,
  ESubRollingOfferCollectBehavior,
  ESaleDiscountDisplayType,
  ECheckoutPageEvent,
  EOrderStatus,
  EResultOptions,
  ESectionsViewModel,
  StoreBodyBlock,
  EStorePhase,
  ESupportType,
  EPlatformType,
  DevicePlatform,
} from '@web-store-platforms/types';

export enum ELoginMode {
  PROVIDERS = 'providers',
  USERNAME = 'userPassword',
  TOKEN_ID = 'tokenId',
  OTP = 'otp',
}

export enum ELoginMethods {
  FACEBOOK = 'facebook',
  GOOGLE = 'google',
  APPLE = 'apple',
  USERNAME = 'userPassword',
  TOKEN = 'userToken',
  OTP = 'otp',
  DEEP_LINK = 'deepLink',
}

export enum EQueryKeys {
  ORDER = 'order',
  BOOT = 'boot',
  PORTAL_BOOT = 'portal_boot',
  STORE_TEMPLATE = 'store_template',
  OFFERS = 'offers',
  PRODUCTS = 'products',
  PAGES = 'pages',
  TRANSLATIONS = 'translations',
}

export enum EerrorCodes {
  PAYMENT = 'payment',
  AUTH = 'auth',
}

export enum EQueryParams {
  MESSAGE = 'msg',
  ORDER_ID = 'order_id',
  ERROR = 'error',
  LOCAL_ADDRESS = 'local_address',
  LOGIN_REDIRECT = 'login_redirect',
  IS_IFRAME = 'is_iframe',
  CURRENCY_CODE = 'currencyCode',
  FROM = 'from',
  TOKEN = 'token',
  OFFER_ID = 'offerId',
  DYNAMO_LINK_ID = 'd10x_link_id',
  DYNAMO_ORG = 'd10x_org',
  REDIRECT_LOGIN_TOKEN = 'redirect_login_token',
  AUTO_COLLECT = 'auto_collect',
  POPUP_ID = 'popup_id',
}

export enum EGradientDirection {
  TopToBottom = 'to bottom',
  BottomToTop = 'to top',
  LeftToRight = 'to right',
  RightToLeft = 'to left',
  TopLeftToBottomRight = 'to bottom right',
  BottomRightToTopLeft = 'to top left',
  TopRightToBottomLeft = 'to bottom left',
  BottomLeftToTopRight = 'to top right',
}

export enum EBalancesTheme {
  DEFAULT = 'default',
  BAGELCODE = 'bagelcode',
  SPACEGO = 'spacego',
  PRODUCT_MADNESS = 'product-madness',
  ME2ON = 'me2on',
  PLAY_SIMPLE = 'play-simple',
  PIPA = 'pipa',
  WHISPERS = 'whispers',
  GHOST = 'ghost',
}

export enum EBannerAspectRatio {
  SQUARE = '1 / 1',
  TWO_ON_THREE = '2 / 3',
}

export enum EPlatform {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
}

export enum EAppleResponseType {
  CODE = 'code',
  ID_TOKEN = 'code id_token',
}

export enum EPostBlockType {
  NEWS = 'news',
  ARTICLE = 'article',
  CONTENT_PREVIEW = 'contentPreview',
}

export enum EBlockType {
  ARTICLE = 'article',
  NEWS = 'news',
  IMAGE = 'image',
  VIDEO = 'video',
  CTA = 'cta',
  IFRAME = 'iframe',
  CONTENTS_PREVIEW = 'contentsPreview',
  DAILY_BONUS = 'dailyBonus',
  PROGRESS_BAR = 'progressBar',
  HTML = 'html',
  OFFER = 'offer',
}

// Block type classification constants
export const COMPONENT_BLOCKS = [
  EBlockType.PROGRESS_BAR,
  EBlockType.HTML,
  EBlockType.OFFER,
] as const;
export const SINGLE_COLUMN_BLOCKS = [EBlockType.DAILY_BONUS] as const;

export enum EPageSection {
  HEADER = 'header',
  MENU = 'menu',
  MENU_SUBITEM = 'menu-subitem',
  ADD_TO_HOME_PAGE = 'add-to-home-page',
  CONTENT = 'content',
  CONTENT_HOME = 'content-home',
  CONTENT_STORE = 'content-store',
  CONTENT_ARTICLE = 'content-article',
  CONTENT_PAGE = 'content-page',
  PAGE = 'page',
}

export enum EEventsType {
  OFFERS_LOADED = 'OFFERS_LOADED',
  PORTAL_PAGE_DISPLAYED = 'PORTAL_PAGE_DISPLAYED',
  PORTAL_CONTENT_DISPLAYED = 'PORTAL_CONTENT_DISPLAYED',
  PORTAL_BLOCK_CLICKED = 'PORTAL_BLOCK_CLICKED',
  PORTAL_FOOTER_CLICKED = 'PORTAL_FOOTER_CLICKED',
  PORTAL_PAGE_CLICKED = 'PORTAL_PAGE_CLICKED',
  PORTAL_LOGIN_DISPLAYED = 'PORTAL_LOGIN_DISPLAYED',
  PORTAL_LOGIN_METHOD_SELECTED = 'PORTAL_LOGIN_METHOD_SELECTED',
  PORTAL_LOGIN_COMPLETED = 'PORTAL_LOGIN_COMPLETED',
  PORTAL_LOGIN_CANCELED = 'PORTAL_LOGIN_CANCELED',
  PORTAL_LOGOUT = 'PORTAL_LOGOUT',
  WEBSTORE_APPROVAL_REQUEST_DISPLAYED = 'WEBSTORE_APPROVAL_REQUEST_DISPLAYED',
  WEBSTORE_APPROVAL_REQUEST_APPROVE = 'WEBSTORE_APPROVAL_REQUEST_APPROVE',
  COLLECT_CLICKED = 'COLLECT_CLICKED',
  COLLECT_RESOLVED = 'COLLECT_RESOLVED',
  OFFER_CLICKED = 'OFFER_CLICKED',
  OUTDATED_OFFER_FAILURE = 'OUTDATED_OFFER_FAILURE',
  ORDER_RESOLVED = 'ORDER_RESOLVED',
  CHECKOUT_OPENED = 'CHECKOUT_OPENED',
  COMPLETE_SCREEN_BACK_TO_SHOP = 'COMPLETE_SCREEN_BACK_TO_SHOP',
  COMPLETE_SCREEN_BACK_TO_GAME = 'COMPLETE_SCREEN_BACK_TO_GAME',
  SHOP_LAND = 'SHOP_LAND',
  COMPLETE_SCREEN_PRESENTED = 'COMPLETE_SCREEN_PRESENTED',
  SUPPORT_FORM_OPEN = 'SUPPORT_FORM_OPEN',
  SUPPORT_FORM_SUBMIT = 'SUPPORT_FORM_SUBMIT',
  SUPPORT_FORM_BACK = 'SUPPORT_FORM_BACK',
  OFFERS_SHOWN = 'OFFERS_SHOWN',
}

export enum EPublisherEvents {
  PORTAL_LOGIN_DISPLAYED = 'portal.login.displayed',
  PORTAL_LOGIN_METHOD_SELECTED = 'portal.login.login_method.selected',
  PORTAL_LOGIN_CANCELED = 'portal.login.canceled',
  PORTAL_LOGIN_COMPLETED = 'portal.login.completed',
  PORTAL_PAGE_DISPLAYED = 'portal.page.displayed',
  PORTAL_CONTENT_DISPLAYED = 'portal.content.displayed',
  PORTAL_BLOCK_CLICKED = 'portal.block.clicked',
  PORTAL_FOOTER_CLICKED = 'portal.footer.clicked',
  PORTAL_PAGE_CLICKED = 'portal.page.clicked',
  WEBSTORE_STORE_DISPLAYED = 'webstore.store.displayed',
  WEBSTORE_OFFERS_DISPLAYED = 'webstore.offers.displayed',
  WEBSTORE_OFFERS_LOADED = 'webstore.offers.loaded',
  WEBSTORE_APPROVAL_REQUEST_DISPLAYED = 'webstore.approval.request.displayed',
  WEBSTORE_APPROVAL_REQUEST_CLOSED = 'webstore.approval.request.closed',
}

export enum EPublisherWebStoreEventType {
  OFFERS = 'offers',
  PRE_LOGIN = 'pre-login',
  POST_LOGIN = 'post-login',
}

export enum ESource {
  STORE_TAB = 'store_tab',
  LOGIN = 'login',
}

export enum ESessionMetadataSource {
  LOGIN_BUTTON_CLICKED = 'login_button_clicked',
  STORE_TAB_CLICKED = 'store_tab_clicked',
}

export enum ECollectType {
  POPUP = 'popup',
  OFFER = 'offer',
}

export enum ELoginResultReason {
  OK = 'OK',
  UNKNOWN = 'unknown',
}

export enum EOTPTextModel {
  SIX_DIGITS = 'sixDigits',
  FOUR_DIGITS = 'fourDigits',
  MOBILE_ONLY = 'mobileOnly',
}

export enum EDesktopNavigationLayout {
  LEFT_SIDEBAR = 'leftSidebar',
  TOP_FIXED_HEADER = 'topFixedHeader',
}

export enum EHttpErrorCodes {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
}
